import { SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import { Input, Props as InputProps } from './Input';
import SendIcon from '@mui/icons-material/Send';
import { Loading } from 'components/Loading';
import { useAmplifyPublishEvent } from 'core/services/amplify/events/useAmplifyPublishEvent';

const inputContainer: SxProps = {
  p: '16px'
};

const sendButtonContainer: SxProps = {
  mb: 0.2,
  p: '15px'
};

type Props = InputProps & {
  conversationId?: string;
  onSend: () => void;
};

export const SendMessageInput: React.FC<Props> = (props) => {
  const { onSend, isLoading, ...rest } = props;

  const { publishEvent } = useAmplifyPublishEvent(
    props.conversationId
      ? {
          channelType: 'ConversationTyping',
          channelParams: {
            conversationId: props.conversationId
          }
        }
      : null
  );

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      onSend();
      return;
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(event);
    if (!props.conversationId) return;
    publishEvent({
      words: event.target.value
    });
  };

  return (
    <Input
      InputProps={{
        endAdornment: (
          <Button
            variant="tertiary"
            sx={sendButtonContainer}
            endIcon={
              isLoading ? (
                <Loading size={16} sx={{ color: 'primary.main' }} />
              ) : (
                <SendIcon />
              )
            }
            disabled={!props.value || props.disabled}
            onClick={onSend}
          >
            Send
          </Button>
        ),
        sx: inputContainer
      }}
      onKeyDown={handleKeyDown}
      multiline
      {...rest}
      onChange={handleChange}
    />
  );
};
